import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { Toast } from 'ngx-toastr';

@Component({
  selector: '[custom-toast-component]',
  imports: [TranslocoPipe, DatePipe],
  templateUrl: './custom-toast.component.html',
  styleUrl: './custom-toast.component.scss',
  preserveWhitespaces: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.with-undo-button]': 'options.payload?.undo',
  },
})
export class CustomToast extends Toast {
  now = signal(new Date());

  action(event: Event) {
    event!.stopPropagation();

    this.toastPackage.triggerAction('undo');
    this.toastrService.clear(this.toastPackage.toastId);

    return false;
  }
}
